import React from 'react';

import { Tabs, TabsContent } from '@/components/ui/tabs';
import { WorkspaceLayout } from '../../shared/components/Layout';
import { useSearchBar } from '../../shared/hooks';
import Dialogs from './components/Dialogs';
import Header from './components/Header';
import { TABS_CONFIG } from './constants';
import {
  BoardProvider,
  DialogProvider,
  FilterProvider,
  ResourcesProvider,
} from './context';

const Workflow = () => {
  const { handleSearchChange, searchInput, searchQuery } = useSearchBar();

  return (
    <WorkspaceLayout>
      <ResourcesProvider>
        <FilterProvider>
          <BoardProvider searchQuery={searchQuery}>
            <DialogProvider>
              <Tabs className="h-full" defaultValue={TABS_CONFIG[0].value}>
                <Header onSearchChange={handleSearchChange} searchInput={searchInput} />

                {TABS_CONFIG.map(({ component: Component, value }) => (
                  <TabsContent className="min-h-0" key={value} value={value}>
                    <Component />
                  </TabsContent>
                ))}
              </Tabs>

              <Dialogs />
            </DialogProvider>
          </BoardProvider>
        </FilterProvider>
      </ResourcesProvider>
    </WorkspaceLayout>
  );
};

export default Workflow;
